(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('hoverOverlay', hoverOverlay);

    function hoverOverlay(lodash, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {
                const elmInstance = elm[0];
                elmInstance.classList.add('hover-overlay');
            },
        };
    }
})();